import moment from 'moment';
import { DataTable } from 'simple-datatables';
import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheBaseServerGet, callTheBaseServerPost } from './helpers/axiosHelper';

import { addDNoneClass, byId } from './helpers/utility';






authHelper.validate();





const getMatchesFun = async () => {
    try {
        const response = await callTheBaseServerGet(`/basic/getMatches`);
        axiosResponseHandler(response);
        const res = response.data;




        const data_table_body = byId('data_table_body');

        if (res.status === 'success') {

            console.log(res.matchesData[0]);
            // adding data to table
            let i = 0;
            while (res.matchesData.length > i) {



                const { sn, title,
                    bannerLink,
                    status,
                    custom_room_details,


                    games,

                    prizePool,
                    perKill,
                    entryFees,
                    playersInTeam,
                    mode,
                    map,

                    time } = res.matchesData[i];

                const date2 = moment(time * 1000).format('DD/MM/YYYY');
                const time2 = moment(time * 1000).format('LT');

                let makeItBtnText = '';

                if (status === 'upcoming') {
                    makeItBtnText = 'ongoing';
                } else if (status === 'ongoing') {
                    makeItBtnText = 'upcoming';
                } else {
                    makeItBtnText = status;
                }

let deleteAndCancelBtnHtml =``;
                if(status === 'upcoming' || status === 'ongoing'){
                    deleteAndCancelBtnHtml =`<button  class="btn btn-success" onclick="cancelMatchFun(${sn})">Cancel</button>`;
                    
                }else{
                    deleteAndCancelBtnHtml =`<button  class="btn btn-success" onclick="deleteMatchFun(${sn})">Delete</button>`;
                }

                data_table_body.innerHTML += `   
                                    <tr>
                                        <th scope="row">${i + 1}</th>
                                        <td>${sn}</td>
                                     
                                      
                                    
                                        <td>${title}</td>
                                       
                                        <td> <img class="img-fluid" src="${bannerLink}" alt="Game Banner" width="200"></td>
                                
                                        <td>${status}</td>
                                        <td>${custom_room_details.roomId}</td>
                                        <td>${custom_room_details.roomPassword}</td>
                                        <td>${games.shortName}</td>
                                        <td>${prizePool}</td>
                                        <td>${perKill}</td>
                                        <td>${entryFees}</td>
                                        <td>${playersInTeam}</td>
                                        <td>${mode}</td>
                                        <td>${map}</td>
                                 
                                   
                                        <td>${date2} <br> ${time2}</td>
                                       
                                        <td> <button  class="btn btn-success " onclick="updateRoomIdAndPassInitFun(${JSON.stringify({ sn, custom_room_details }).split('"').join('&quot;')})">Id&Pass</button> </td>
                                        <td> <button  class="btn btn-success " onclick="updateMatchStatusFun(${sn},'${status}')">${makeItBtnText}</button> </td>
                                        <td> <a href='./getJoinings.html?matchId=${sn}'  class="btn btn-success ">Joinings</a> </td>
                                      
                                        <td> <a href='./updateResult.html?matchId=${sn}'  class="btn btn-success ">Result</a> </td>
                                        <td> ${deleteAndCancelBtnHtml} </td>
                                    
                           
                                    </tr>
                                    `;
                i++;
            }

            // Initiate Datatables



            const simpleDatatables = new DataTable('#data_table', {
                // searchable: false,
                // perPageSelect: false,


            });
            simpleDatatables;

        }


    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }




};

getMatchesFun();



const deleteMatchFun = async (sn) => {
    try {
        const response = await callTheBaseServerGet(`/basic/deleteMatch/${sn}`);
        axiosResponseHandler(response);
        const res = response.data;

        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'Match  Deleted',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }
    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }

};

window.deleteMatchFun = deleteMatchFun;
const cancelMatchFun = async (sn) => {
    try {
        const response = await callTheBaseServerGet(`/basic/cancelMatch/${sn}`);
        axiosResponseHandler(response);
        const res = response.data;

        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'Match  Cancelled',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }
    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }

};

window.cancelMatchFun = cancelMatchFun;


const updateRoomIdAndPassCardDivElement = byId('updateRoomIdAndPassCardDivElement');
const oldRoomIDInput = byId('oldRoomIDInput');
const oldRoomPasswordInput = byId('oldRoomPasswordInput');
const NewRoomIDInput = byId('NewRoomIDInput');
const newRoomPasswordInput = byId('newRoomPasswordInput');
const lastUpdatedAtInput = byId('lastUpdatedAtInput');
const MatchIdInput = byId('MatchIdInput');

const updateRoomIdAndPassInitFun = async (obj) => {
    addDNoneClass(updateRoomIdAndPassCardDivElement, false);

    const { sn, custom_room_details } = obj;

    oldRoomIDInput.value = NewRoomIDInput.value = custom_room_details.roomId;
    oldRoomPasswordInput.value = newRoomPasswordInput.value = custom_room_details.roomPassword;

    lastUpdatedAtInput.value = (custom_room_details.updatedAt) ? moment(custom_room_details.updatedAt * 1000).fromNow() : 'Never';
    MatchIdInput.value = sn;



};

window.updateRoomIdAndPassInitFun = updateRoomIdAndPassInitFun;

const updateRoomIdAndPassCancelFun = () => {
    addDNoneClass(updateRoomIdAndPassCardDivElement, true);
};

const updateRoomIdAndPassCancelBtn = byId('updateRoomIdAndPassCancelBtn');

updateRoomIdAndPassCancelBtn.addEventListener('click', updateRoomIdAndPassCancelFun);



const updateRoomIdAndPassSubmitFun = async () => {

    const matchId = MatchIdInput.value;
    const roomId = NewRoomIDInput.value;
    const roomPassword = newRoomPasswordInput.value;
    const formData = {
        matchId,
        roomId,
        roomPassword,

    };

    try {
        const response = await callTheBaseServerPost(`/basic/updateRoomIdAndPass`, { data: formData });
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'RoomIdAndPass Updated',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }

    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }

};

const updateRoomIdAndPassSubmitBtn = byId('updateRoomIdAndPassSubmitBtn');
updateRoomIdAndPassSubmitBtn.addEventListener('click', updateRoomIdAndPassSubmitFun);


const updateMatchStatusFun = async (sn, oldStatus) => {
    let newStatus;
    if (oldStatus === 'upcoming') {
        newStatus = 'ongoing';
    } else if (oldStatus === 'ongoing') {
        newStatus = 'upcoming';
    } else {
        return false;
    }
    const status = newStatus;

    const formData = {
        sn,
        status,


    };

    try {
        const response = await callTheBaseServerPost(`/basic/updateMatchStatus`, { data: formData });
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'match Status Updated',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }
    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }

};

window.updateMatchStatusFun = updateMatchStatusFun;



